export default "__VITE_ASSET__CHw$ylkU__"